<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <div class="industry-box">
          <span>产业筛选</span>
          <el-select v-model="selectIndustry" clearable placeholder="请选择产业" @change="handleIndustry">
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="right" slot="right">
        <el-button
          v-show="hasAuthority('addServeClassify')"
          type="primary"
          class="excel"
          @click="handlerAdd()">
          新增分类</el-button>
      </div>
    </Nav>
    <table-pagination
      ref="table"
      :config="config"
      class="table"
      :datasource="datasource"
      @change-page="handlerPageChange">
      <el-table-column
        slot="action"
        label="操作"
        width="440"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              v-show="hasAuthority('editServeClassify')"
              :underline="false"
              type='primary'
              class="details"
              @click="handlerRouter('set', scope)">
              编辑</el-link>
            <el-link
              v-show="hasAuthority('deleteServeClassify')"
              style="margin-left: 5px"
              :underline="false"
              type='primary'
              class="details"
              @click="event().deleteServe(scope)">
              删除</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import TablePagination from '@/components/table-pagination'
import { getClassifyList, deleteClassify } from '@/api/serve'
import { getIndustrySelectList } from '@/api/industry'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 1,
        industryUuid: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'indexNum',
            label: '排列序号',
            width: '350'
          },
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'industryName',
            label: '所属产业'
          },
          {
            prop: 'picture',
            label: '分类图片',
            type: 'image',
            imgH: '100',
            imgW: '100'
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      industryList: [],
      selectIndustry: ''
    }
  },
  created() {
    this.network().getClassifyList()
    this.network().getIndustrySelectList()
  },
  methods: {
    event() {
      return {
        deleteServe: (scope) => {
          this.$confirm('是否删除该分类管理？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.network().deleteClassify(scope.row.uuid)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
        }
      }
    },
    network() {
      return {
        getClassifyList: async() => {
          const { data } = await getClassifyList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        deleteClassify: async(uuid) => {
          await deleteClassify(uuid)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.network().getClassifyList()
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getClassifyList()
    },
    handlerAdd() {
      this.$router.push({ path: '/serve-management/classify-management/add' })
    },
    handlerRouter(type, scope) {
      if (type === 'set') {
        this.$router.push({ path: `/serve-management/classify-management/set/${scope.row.uuid}`,
          query: { info: scope.row }})
      }
    },
    handleIndustry() {
      this.body.industryUuid = this.selectIndustry
      this.body.pageIndex = 1
      this.network().getClassifyList()
    }
  },
  components: {
    Nav,
    TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
    .left{
      .status{
        span{
          margin-right: 15px;
        }
      }
    }
  }
  .industry-box{
    span{
      margin-right: 15px;
    }
  }
}
</style>
